<template>
<div>

    <v-select
        label="Send Mode"
        :items="send_modes"
        :value="value.send_mode"
        v-on:change="onChangeSendMode"
        :disabled="disable_mode"
    />
    
    <v-select
        label="Send From"
        :items="send_from_choices"
        :value="value.send_from"
        
        v-on:change="onChangeSendFrom"
    />

    <v-select
        label="Link Shortener Host"
        :items="link_shortener_host_choices"
        :value="value.link_shortener_host"
        
        v-on:change="onChangeLinkShortener"
    />

    <m-edit-message-patterns-compact
        :value="value.message_patterns"
        :context="message_pattern_context"
        v-on:input="onChangeMessagePatterns"
        style="margin-top: 15px; margin-bottom: 30px"
    />

    <v-row
        v-if="default_message_control"
    >
        <v-col>
            <m-edit-text
                label="Delay before sending"
                :value="value.time_delay_send_after_enqueue"
                duration
                v-on:input="onChangeDelayBeforeSendingDefault"
            />
        </v-col>

        <v-col>
            <m-edit-text
                label="Expire if not sent within"
                :value="value.time_delay_expire_after_trigger"
                duration
                v-on:input="onChangeExpirationDefault"
            />
        </v-col>
    </v-row>

    <v-row
        v-if="!default_message_control"
    >
        <v-col>
            <m-edit-text
                label="Custom delay before sending"
                :value="value.custom_time_delay_send_after_enqueue"
                duration
                v-on:input="onChangeDelayBeforeSendingCustom"
                unset_label="Remove"
            />
        </v-col>
        <v-col>
            <m-edit-text
                label="Custom expire if not sent within"
                :value="value.custom_time_delay_expire_after_trigger"
                duration
                v-on:input="onChangeExpirationCustom"
                unset_label="Remove"
            />
        </v-col>
    </v-row>


</div>
</template>

<script>
const _ = require('lodash');

export default {
    props: {

        message_pattern_context: {
            type: String,
            default: function() { return ''; }
        },

        send_from_choices: {
            type: Array,
            default: function() { return []; }
        },

        value: {
            type: Object,
            default: function() { return []; }
        },

        link_shortener_host_choices: {
            type: Array,
            default: function() { return []; }
        },

        disable_mode: {
            type: Boolean,
            default: function() { return false; }
        },

        default_message_control: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
             send_modes: [
                { 'text' : 'Disabled', 'value' : 'disabled'},
                { 'text' : 'Manual', 'value' : 'manual'},
                { 'text' : 'Automatic', 'value' : 'auto'},
            ],
        }
    },

    methods: {
        onChangeMessagePatterns(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.message_patterns = new_value;
            this.$emit('input', emit_value);
        },

        onChangeSendMode(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.send_mode = new_value;
            this.$emit('input', emit_value);
        },

        onChangeSendFrom(new_value) 
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.send_from = new_value;
            this.$emit('input', emit_value);
        },

        onChangeLinkShortener(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.link_shortener_host = new_value;
            this.$emit('input', emit_value);
        },

        onChangeDelayBeforeSendingDefault(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.time_delay_send_after_enqueue = new_value;
            this.$emit('input', emit_value);
        },

        onChangeExpirationDefault(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.time_delay_expire_after_trigger = new_value;
            this.$emit('input', emit_value);
        },

        onChangeDelayBeforeSendingCustom(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.custom_time_delay_send_after_enqueue = new_value;
            this.$emit('input', emit_value);
        },

        onChangeExpirationCustom(new_value)
        {
            let emit_value = _.cloneDeep(this.value);
            emit_value.custom_time_delay_expire_after_trigger = new_value;
            this.$emit('input', emit_value);
        },
    },

}
</script>

<style lang="scss" scoped>

</style>